export default __webpack_public_path__ + "f0f238996936edd960766e32899c3321.svg";